<script>
  import axios from 'axios'
  import { getURL } from '../utils'
  import { onMount } from 'svelte'
  import { userStore, is } from '../store'

  export let menuLinks = [
    {ref: 'https://www.flexlink.com/en/about-us/facts-and-figures', title: 'ABOUT US'},
    {ref: 'https://www.flexlink.com/en/industries/automotive', title: 'INDUSTRIES'},
    {ref: 'https://www.flexlink.com/en/portfolio/production-flow/consulting', title: 'PORTFOLIO'},
    {ref: 'https://www.flexlink.com/en/solutions/products', title: 'SOLUTIONS'},
    {ref: 'https://www.flexlink.com/en/services/maintenance-services', title: 'SERVICES'},
    {ref: 'https://www.flexlink.com/en/support/engineering-tools', title: 'SUPPORT'}
  ]

  export let adminLinks = [
    {ref: '/#/settings', title: 'SETTINGS'}
  ]

  export let links = [
    {title: 'Discover Group', ref: 'https://www.coesia.com/en/group'},
    {title: 'People', ref: 'https://www.coesia.com/en/people'},
    {title: 'Career Opportunities', ref: 'https://www.coesia.com/en/career-opportunities-flexlink'},
    {title: 'Blog', ref: 'https://blog.flexlink.com/'},
    {title: 'My Flexlink', ref: 'https://my.flexlink.io/'},
    {title: 'Online Store', ref: 'https://my.flexlink.com/myflexlink/applicationstartauth.htm?app=1000'}
  ]

  export let bottomLinks = [
    {title: 'Contact us', ref: 'https://www.flexlink.com/en/contact-us'},
    {title: 'Legal info', ref: 'https://www.flexlink.com/en/about-us/legal/legal-info'},
    {title: 'Privacy policy', ref: 'https://www.flexlink.com/en/about-us/legal/privacy-policy'},
    {title: 'Cookie policy', ref: 'https://www.flexlink.com/en/about-us/legal/cookie-policy'},
    {title: 'Terms and conditions', ref: 'https://www.flexlink.com/en/about-us/business-documents#termsconditions'},
    {title: 'UK tax strategy', ref: 'https://www.flexlink.com/en/about-us/legal/legal-info#uktaxstrategy'}
  ]

  export let social = [
    {alt: 'Linked In', src: 'icon-footer-linkedin.svg', ref: 'https://linkedin.com/company/flexlink/'},
    {alt: 'YouTube', src: 'icon-footer-youtube.svg', ref: 'https://www.youtube.com/user/flexlinkmarketing'},
    {alt: 'Twitter', src: 'icon-footer-twitter.svg', ref: 'https://twitter.com/FlexLink'}
  ]

  $:  {
    if (is($userStore.roles, 'ib_admin', 'admin')) { menuLinks = [...menuLinks, ...adminLinks]}
  }

  let version = "0.0.1"
  let ib_version = "0.0.1"
  let year = "2022"

  onMount(() => {
    const url = getURL('/about')
    axios.get(url)
    .then(res => {
      version = res.data.version
    })
    .catch(err => {
      console.log('[ERROR] get about', err)
    })

    const ib_url = getURL('/ib/about')
    axios.get(ib_url)
      .then(res => {
        ib_version = res.data.version
      })
      .catch(err => {
        console.log('[ERROR] get ib_about', err.message)
      })

    year = new Date().getFullYear();
  })

</script>

<footer class="text-left px-24 pb-10 text-lg tracking-wider font-light flex flex-wrap">

  <div class="flex flex-row w-full pt-16 menu">

    <div class="flex flex-wrap w-7/12 menu">
      {#each menuLinks as link}
        <div class="pr-3 pb-2"><a href={link.ref}>{link.title}</a></div>
      {/each}
    </div>

    <div class="flex flex-row w-5/12 special">

      <div class="w-1/4 border-l border-gray-200 separator"></div>
      <div class="w-1/3 flex flex-col flex-grow flex-nowrap">
        {#each links as link}
          <div style="line-height: 2rem;">
            <a href={link.ref}>{link.title}</a>
          </div>
        {/each}
      </div>

      <div class="w-1/3 flex-col follow-us">
        <span class="mb-2">Follow us</span>
        <div class="flex">
          {#each social as s}
            <a href={s.ref}><img src={`static/img/${s.src}`} alt={s.alt}></a>
          {/each}
        </div>
      </div>
    </div>

  </div>

  <div class="flex w-full text-sm leading-5 site-notice menu">
    <div class="mr-2">&copy FlexLink {year} - All rights reserved -</div>
    {#each bottomLinks as bl}
      <div class="mr-2" ><a href={bl.ref}>{bl.title}</a></div>
    {/each}
  </div>

  <div class="flex w-full text-sm leading-5 site-notice menu">
    <div class="mr-2">Portal: {version}</div>
    <div>Installed base: {ib_version}</div>
  </div>

</footer>

<style>
  footer {
    min-height: 272px;
    background-color: #222222;
    color: #f0f0f0;
  }

  footer a, footer a:visited {
    text-decoration: none;
    color: #f0f0f0;
  }

  footer .test{
    width: 41.666667%;
  }

  footer .follow-us img{
    margin-right: 0.625em;
    position: relative;
  }

  footer .site-notice {
    font-size: 0.85em;
    color: #777777;
  }

  footer .site-notice a {
    color: #777777;
  }

  footer .menu{
    flex-direction: row;
    line-height: 2rem;
  }

  @media only screen and (max-width: 768px) {
    footer .menu{
      flex-direction: column;
      margin-bottom: 2rem;
    }

    footer .separator{
      display: none;
    }

    footer .special{
      width: 100%;
      justify-content: space-between;
    }
  }
</style>
